module.exports = __webpack_public_path__ + "img/PerksNextLevel.0fde8438.png";